import { EventBus, ITG_RENDER_CHANNEL } from "@ceeferenderer/itg-renderer-sdk";
import { process } from "./process";
import { receiver } from "./receiver";
import "./validation";

export const flow = (): void => {
  EventBus.subscribe(ITG_RENDER_CHANNEL, receiver);
  process();
};
